/**
 * SAHINKAYA_GUNCELLEMESI - Consultation Body Class Fix
 * 
 * Sorun: Yeni Shopify tema versiyonunda dil değiştirildiğinde sayfa yenileniyor
 * ve body class'ları bazen düzgün oluşmuyor. Bu script, sayfa her yüklendiğinde
 * consultation template ve customer bilgilerini kontrol ederek body class'larını
 * düzeltir.
 * 
 * ÇÖZÜM: Localization form'larını intercept edip class'ları sessionStorage'a kaydet,
 * sayfa reload sonrası bu class'ları geri yükle ve consultation butonlarını manuel gizle.
 * 
 * Tarih: 7 Mart 2026
 */

(function() {
  'use strict';
  
  /**
   * Localization form'larını intercept et ve class'ları kaydet
   */
  function interceptLocalizationForms() {
    const localizationForms = document.querySelectorAll('form[action*="/localization"]');
    
    if (localizationForms.length > 0) {
      localizationForms.forEach(form => {
        form.addEventListener('submit', function(e) {
          // Eğer consultation template'deysek, class'ları kaydet
          if (document.body.classList.contains('template-suffix-consultation')) {
            sessionStorage.setItem('sahinkaya-body-classes', document.body.className);
          }
          return true;
        });
      });
    }
  }
  
  /**
   * Body class'larını kontrol et ve consultation butonlarını gizle
   */
  function ensureConsultationClasses() {
    const body = document.body;
    
    // Önceki sayfadan kaydedilmiş class'lar varsa geri yükle
    const savedClasses = sessionStorage.getItem('sahinkaya-body-classes');
    if (savedClasses) {
      // Template suffix class'ını ekle
      if (savedClasses.includes('template-suffix-consultation') && !body.classList.contains('template-suffix-consultation')) {
        body.classList.add('template-suffix-consultation');
      }
      
      // Customer class'larını ekle
      if (savedClasses.includes('customer--logged-in') && !body.classList.contains('customer--logged-in')) {
        body.classList.add('customer--logged-in');
      }
      
      if (savedClasses.includes('customer--has-approved-pricing') && !body.classList.contains('customer--has-approved-pricing')) {
        body.classList.add('customer--has-approved-pricing');
      }
      
      sessionStorage.removeItem('sahinkaya-body-classes');
    }
    
    // Consultation template'de ve approved customer değilse butonları gizle
    if (body.classList.contains('template-suffix-consultation') && 
        !body.classList.contains('customer--has-approved-pricing')) {
      
      // Tüm buy button elementlerini gizle
      const selectors = [
        'form[action="/cart/add"]',
        'product-form',
        'buy-buttons',
        '.product-form',
        '.product-form__buttons',
        '.buy-buttons',
        '.shopify-payment-button',
        'button[name="add"]',
        '[type="submit"][name="add"]'
      ];
      
      selectors.forEach(selector => {
        document.querySelectorAll(selector).forEach(el => {
          el.style.setProperty('display', 'none', 'important');
        });
      });
      
      // Quantity selector'u da gizle
      document.querySelectorAll('.quantity-selector, quantity-selector').forEach(el => {
        el.style.setProperty('display', 'none', 'important');
      });
    }
  }
  
  // Form'ları intercept et
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', interceptLocalizationForms);
  } else {
    interceptLocalizationForms();
  }
  
  // Body class'larını düzelt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureConsultationClasses);
  } else {
    ensureConsultationClasses();
  }
  
  // Ek güvenlik: Sayfa tamamen yüklendikten sonra bir kez daha kontrol et
  window.addEventListener('load', function() {
    setTimeout(ensureConsultationClasses, 50);
    setTimeout(ensureConsultationClasses, 200);
    setTimeout(ensureConsultationClasses, 500);
    setTimeout(ensureConsultationClasses, 1000);
    setTimeout(ensureConsultationClasses, 2000);
  });
  
  // MutationObserver ile DOM değişikliklerini izle
  const observer = new MutationObserver(function(mutations) {
    // Eğer buy button eklendiyse kontrol et
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) { // Element node
          const form = node.querySelector?.('form[action="/cart/add"]') || 
                      (node.matches?.('form[action="/cart/add"]') ? node : null);
          
          if (form) {
            setTimeout(ensureConsultationClasses, 100);
          }
        }
      });
    });
  });
  
  // Body'yi izle
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Shopify section render olduğunda da kontrol et
  if (window.Shopify?.designMode) {
    document.addEventListener('shopify:section:load', function() {
      ensureConsultationClasses();
      interceptLocalizationForms();
    });
  }
  
})();
